import {
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetLogVisitorsForLeads = async (leadId) => {
  /**
   * input: null
   * output: log visitor object
   * description: fetches all visitors
   */
  console.log("leadVisitsData",leadId);
  try {
    const visitorCollection = query(
      collection(db, "visits"),
      where("client.id", "==", leadId),
    );

    const logVisitorSnapshot = await getDocs(visitorCollection);
    console.log("leadVisitsData",logVisitorSnapshot);

    let logVisitors = [];
    logVisitorSnapshot.forEach((visitor) =>
      logVisitors.push({ id: visitor.id, ...visitor.data() })
    );

    return logVisitors;
  } catch (error) {
    console.log(error);
  }
};

export default GetLogVisitorsForLeads;
